





























import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import Moment from "moment-timezone";
import "@/assets/css/table.css";

class PageReadListRequest {
    deviceId: string;
    startTime: string;
    endTime: string;
    page: number;
    pageSize: number;
    sortBy: string;
    descending: boolean;
    filterFileds: any;
}
@Component({
    components: {},
})
export default class CycleData extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: String, default: "" }) meterId: string;
    pagerequest: PageReadListRequest = new PageReadListRequest();
    customerlist: any[] = [];
    create() { }
    created() {
        this.pagerequest.startTime = Moment().format("YYYY-MM-DD");
        this.$store.commit("meterinteruse/setCurrentPage", 1);
        //console.log(this.pagerequest)
    }
    changdate(val) {
        this.pagerequest.startTime = val;

    }
    get list() {
        return this.$store.state.meterinteruse.list;
    }
    cancel() {
        this.$store.commit("meterinteruse/setCurrentPage", 1);
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
            this.$store.commit("meterinteruse/setCurrentPage", 1);
        } else {
            this.pagerequest.sortBy = "gatherTime";
            this.pagerequest.descending = true;
            this.getpage();
        }

    }
    data() {
        return {
            arealist: [],
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                };
            },
            datepicker: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
        };
    }
    pageChange(page: number) {
        this.$store.commit("meterinteruse/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("meterinteruse/setPageSize", pagesize);
        this.getpage();
    }
    changeSort(key) {
        if (key.order === "desc" || key.order === "normal") {
            //this.pagerequest.sortBy = key.key + " " + key.order;
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = true;
        } else {
            this.pagerequest.sortBy = key.key;
            this.pagerequest.descending = false;
        }
        this.getpage();
    }
    async getpage() {
        this.pagerequest.pageSize = this.pageSize;
        this.pagerequest.page = this.currentPage;
        this.$store.state.meterinteruse.loading = true;
        await this.$store
            .dispatch({
                type: "meterinteruse/meterInterData",
                data: this.pagerequest,
            })
            .then((val) => {
                console.log(val);
                this.$store.state.meterinteruse.totalCount = val.total;
                this.$store.state.meterinteruse.list = val.rows;
                this.$store.state.meterinteruse.loading = false;
            }).catch((err) => {
                this.$store.state.meterinteruse.loading = false;
            })

    }
    get pageSize() {
        return this.$store.state.meterinteruse.pageSize;
    }
    get totalCount() {
        return this.$store.state.meterinteruse.totalCount;
    }
    get currentPage() {
        return this.$store.state.meterinteruse.currentPage;
    }
    get loading() {
        return this.$store.state.meterinteruse.loading;
    }
    columns = [
        {
            type: "index",
            width: 80,
            align: "left",
            title: this.L("IndexNo"),
        },
        {
            title: this.L("MeterNo"),
            key: "deviceNo",
            width: 160,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.deviceNo,
                        },
                    },
                    params.row.deviceNo
                );
            },
        },
        {
            title: this.L("ReadTime"),
            key: "gatherTime",
            width: 150,
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.gatherTime == null
                        ? ""
                        : Moment(params.row.gatherTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("Interval"),
            key: "interval",
            width: 130,
        },
        {
            title: this.L("FirstReadNum"),
            key: "openingNum",
            width: 130,
        },
        {
            title: this.L("LastReadNum"),
            key: "endingNum",
            width: 130,
        },
        {
            title: this.L("ThisUse"),
            key: "thisUse",
            width: 130,
        },
    ];
    @Watch("meterId")
    getitemId() {
        this.pagerequest.deviceId = this.meterId;
    }
}
